import { render, staticRenderFns } from "./breadcrumbButton.vue?vue&type=template&id=2a8daeed&scoped=true&"
import script from "./breadcrumbButton.vue?vue&type=script&lang=js&"
export * from "./breadcrumbButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8daeed",
  null
  
)

export default component.exports